import { AVAILABLE_POST_COMMENTS } from "../actions/types";

let commentsDataState = { comments: [], totalPages: 0, currentPage: 1 };

export default function (state = commentsDataState, action) {

    switch (action.type) {
        case AVAILABLE_POST_COMMENTS:
            if (state.comments.length === 0) {
                return {
                    ...state,
                    comments: action.payload.content.comments,
                    totalPages: action.payload.content.totalPages,
                    currentPage: parseInt(action.payload.content.currentPage),
                }
            } else {
                let concatResult = {};
                concatResult.comments = state.comments.concat(action.payload.content.comments);
                concatResult.totalPages = action.payload.content.totalPages;
                concatResult.currentPage = parseInt(action.payload.content.currentPage);
                return {
                    ...state,
                    comments: concatResult.comments,
                    totalPages: concatResult.totalPages,
                    currentPage: concatResult.currentPage,
                }
            }

       
        default:
            return state;
    }
}

